import { render, staticRenderFns } from "./ControllerDate.vue?vue&type=template&id=1172516d&scoped=true&"
import script from "./ControllerDate.vue?vue&type=script&lang=js&"
export * from "./ControllerDate.vue?vue&type=script&lang=js&"
import style0 from "./ControllerDate.vue?vue&type=style&index=0&id=1172516d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172516d",
  null
  
)

export default component.exports